import BaseLevelScene from './BaseLevelScene';

export default class PoeMuseumBasementScene extends BaseLevelScene {
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  constructor() {
    super('Poe Museum Basement');
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the train PNG file
    this.load.image('medieval_interior_tiles', 'assets/sourceImages/medieval tileset interior.png');

    // load the JSON map
    this.load.tilemapTiledJSON(
      'poe_museum_basement_tilemap',
      'assets/scenes/OldStoneHouseBasement.json'
    );
  }

  create() {
    // 👌 sanity check by displaying the entire tileset image
    // this.add.image(0, 0, 'sewer_tiles');

    // create the Tilemap
    this.map = this.make.tilemap({ key: 'poe_museum_basement_tilemap' });

    // add the tileset  images we are using
    const baseTileset = this.map.addTilesetImage('medieval_interior', 'medieval_interior_tiles');

    // create the layers we want in the right order
    const floor = this.map.createLayer('BaseLayer', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(floor);

    // add any additional textures over the base layer
    const textures = this.map.createLayer('Textures', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(textures);

    // add furniture
    const furniture = this.map.createLayer('Furniture', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture);

    // add miscelaneous stuff
    const stuff = this.map.createLayer('Stuff', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(stuff);

    // create base level
    this.createBaseLevel(0.4, 4);
  }
}
